<template>
  <v-btn
    class="btn btn--depressed bg-grey-lighten-1 google-maps-link text-white text-uppercase mt-5"
    :href="`https://maps.google.com/?q=${address}`"
    target="_blank"
    rel="noopener"
    size="small"
  >
    {{ $t('openGoogleMaps') }}
  </v-btn>
</template>

<script setup lang="ts">
defineProps({
  address: {
    type: String,
    required: true
  }
})
</script>

<style scoped>
a {
  text-decoration: none !important;
}
</style>
